import type {BusinessFeeNegotiationRound} from '@afriex/core/domain/types';

import {Table, TBody, Td, Th, Thead, Tr} from '@/components';

import {
  formatDayTime,
  formatRoundAuthor,
  formatRoundOffer,
} from './negotiationFormat';

/** Every offer on a request, newest first, in the house audit table shape. */
const NegotiationRoundsTable = ({
  rounds,
}: {
  rounds: BusinessFeeNegotiationRound[];
}) => {
  const ordered = [...rounds].reverse();

  if (!ordered.length) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400 py-3">
        No activity yet.
      </p>
    );
  }

  return (
    <div className="max-h-[400px] overflow-y-auto overflow-x-hidden">
      <Table>
        <Thead>
          <Tr enableHover={false}>
            <Th className="px-4 py-2 text-left">Date</Th>
            <Th className="px-4 py-2 text-left">By</Th>
            <Th className="px-4 py-2 text-left">Offer</Th>
            <Th className="px-4 py-2 text-left">Note</Th>
          </Tr>
        </Thead>
        <TBody>
          {ordered.map((round) => (
            <Tr key={round.id}>
              <Td className="px-4 py-2">{formatDayTime(round.at)}</Td>
              <Td className="px-4 py-2">{formatRoundAuthor(round)}</Td>
              <Td className="px-4 py-2 whitespace-normal">
                {formatRoundOffer(round)}
              </Td>
              <Td className="px-4 py-2 whitespace-normal break-words min-w-[12rem]">
                {round.note ?? '-'}
              </Td>
            </Tr>
          ))}
        </TBody>
      </Table>
    </div>
  );
};

export default NegotiationRoundsTable;
